var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainUnichain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EA40BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.038v13.87M19 11.966H5M18.968 11.967A6.968 6.968 0 0112 5M5.032 11.972a6.968 6.968 0 016.969 6.968",
    stroke: "#F50DB4",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMi4wMDAxIiByPSIxMiIgZmlsbD0id2hpdGUiLz4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxMiIgY3k9IjEyLjAwMDEiIHI9IjEyIiBmaWxsPSIjRUE0MEJBIi8+CjxwYXRoIGQ9Ik0xMi4wMDAyIDUuMDM4MzNWMTguOTA4MSIgc3Ryb2tlPSIjRjUwREI0IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBkPSJNMTkuMDAwMiAxMS45NjYxSDUuMDAwMjQiIHN0cm9rZT0iI0Y1MERCNCIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTE4Ljk2ODIgMTEuOTY3MkMxNS4xMTk5IDExLjk2NzIgMTIuMDAwMiA4Ljg0NzU2IDEyLjAwMDIgNC45OTkyNyIgc3Ryb2tlPSIjRjUwREI0IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBkPSJNNS4wMzI0NyAxMS45NzE5QzguODgwNzcgMTEuOTcxOSAxMi4wMDA1IDE1LjA5MTYgMTIuMDAwNSAxOC45Mzk5IiBzdHJva2U9IiNGNTBEQjQiIHN0cm9rZS13aWR0aD0iMS4yIi8+Cjwvc3ZnPgo=";
export { SvgChainUnichain as ReactComponent };